import React, { useEffect, useState } from 'react';
import { convertEthToUSD2, getLendingContractBalance, getTotalRewards, getTotalSupply, hourlyRewards } from '../../functions/lendingfunctions';

export default function Stats() {
  const [totalLended, settotalLended] = useState(0);
  const [protocolRewards, setProtocolRewards] = useState(0);
  const [lendedEthereum, setLendedEthereum] = useState(0);
  const [totalBorrowed, setTotalBorrowed] = useState(0);
  const [hourlyLPStat, sethourlyLPStat] = useState(0);
  const [hourlyProtocolStat, sethourlyProtocolStat] = useState(0);

  // A helper function to animate counting from `start` to `end`
  function animateValue(start, end, duration, onUpdate) {
    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const fraction = Math.min(progress / duration, 1); // from 0 to 1
      const currentValue = Math.floor(start + fraction * (end - start));
      onUpdate(currentValue);
      if (fraction < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  useEffect(() => {
    async function fetchStats() {
      try {
        const atRewards = await getTotalRewards()
        const atUSD = await convertEthToUSD2(atRewards)
        const totalLended = await getTotalSupply()
        const hourlyLP = await hourlyRewards(0)
        const contractBalance = await getLendingContractBalance()
        const ETHborrowed = totalLended - contractBalance
        setTotalBorrowed(await convertEthToUSD2(ETHborrowed))
        const hourlyProtocol = await hourlyRewards(1)
        sethourlyProtocolStat(hourlyProtocol+hourlyLP)
        sethourlyLPStat(hourlyProtocol+hourlyLP)


        settotalLended(await convertEthToUSD2(contractBalance))
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    }

    fetchStats();
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-12">
      <div className="hidden sm:flex relative h-44 rounded-lg bg-gradient-to-t from-[#ffffff04] to-transparent border border-white/10 flex-col items-center justify-center">
        <div className="flex flex-col items-center mb-2 gap-2">
          <span className="text-3xl font-bold">${(hourlyProtocolStat === null || !(hourlyProtocolStat === 0)  ) ? hourlyProtocolStat : "-"}/d</span>
        </div>
        <div className="text-[14px] font-[300] kanit-light text-gray-500">
          Total Daily Earnings
        </div>
      </div>
      {/* 1. Total LP Rewards */}
      <div className="relative h-44 rounded-lg  bg-gradient-to-t from-[#ffffff04] to-transparent border border-white/10 flex flex-col items-center justify-center">
        <div className="flex flex-col items-center mb-2 gap-2">
          <span className="text-3xl font-bold">${(totalLended === null || !(totalLended === 0)  ) ? Math.round(totalLended*1000)/1000 : "-"} </span>
        </div>
        <div className="text-[13px] font-[300] kanit-light text-gray-500">
        Total Available ETH
        </div>
      </div>
      {/* 3. Total Lended Ethereum */}

      {/* 2. Total Protocol Rewards 
      <div className="relative h-44 rounded-lg  from-white/5 to-transparent border border-white/10 flex flex-col items-center justify-center">
        <div className="flex flex-col items-center mb-2 gap-2">
          <span className="text-3xl font-bold">${hourlyLPStat}</span>
        </div>
        <div className="text-sm font-[300] kanit-light text-gray-500">
          LP Hourly Earnings 
        </div>
      </div>*/}
      <div className="hidden lg:flex relative h-44 rounded-lg  bg-gradient-to-t from-[#ffffff04] to-transparent border border-white/10  flex-col items-center justify-center">
        <div className="flex flex-col items-center mb-2 gap-2">
          <span className="text-3xl font-bold">${(totalBorrowed === null || !(totalBorrowed === 0)  ) ? Math.round(totalBorrowed*1000)/1000 : "-"}  </span>
        </div>
        <div className="text-sm font-[300] kanit-light text-gray-500">
          Total Borrowed 
        </div>
      </div>

    </div>
  );
}
